import React from 'react';
import { Chip, Paper } from '@mui/material';
import RichTextEditor from '../../richTextEditor/components/RichTextEditor';
import AccurityIcon from '../../icon/components/AccurityIcon';
import { objectTypeToIconName } from '../../icon/utils';
var CardListItem = function (_a) {
    var item = _a.item, onRelatedObjectClick = _a.onRelatedObjectClick, onTagClick = _a.onTagClick, onCardClick = _a.onCardClick, onChipClick = _a.onChipClick;
    var objectType = item.objectType, description = item.description, chips = item.chips, name = item.name, synonym = item.synonym, _b = item.relatedObjects, relatedObjects = _b === void 0 ? [] : _b, _c = item.tags, tags = _c === void 0 ? [] : _c;
    var handleRelatedObjectClick = function (e, relatedObject) {
        if (onRelatedObjectClick) {
            onRelatedObjectClick(relatedObject);
            e.stopPropagation();
        }
    };
    var handleTagClick = function (e, tag) {
        if (onTagClick) {
            onTagClick(tag);
            e.stopPropagation();
        }
    };
    var handleTitleClick = function () {
        if (onCardClick) {
            onCardClick(item);
        }
    };
    return (React.createElement("div", { className: "cardListItem" },
        React.createElement(Paper, null,
            React.createElement("div", { className: "cardListItem__header" },
                React.createElement(AccurityIcon, { iconName: objectTypeToIconName(objectType) }),
                React.createElement("div", { className: "cardListItem__headerTitle", onClick: handleTitleClick }, name)),
            synonym && React.createElement("div", { className: "cardListItem__synonym" },
                "Synonym: ",
                synonym),
            relatedObjects && relatedObjects.length > 0 && React.createElement("div", { className: "cardListItem__chips" }, relatedObjects.map(function (relatedObject) { return React.createElement(Chip, { label: relatedObject.name, onClick: function (e) { return handleRelatedObjectClick(e, relatedObject); }, icon: React.createElement(AccurityIcon, { iconName: objectTypeToIconName(relatedObject.objectType), fontSize: "small" }), key: relatedObject.objectType + "-" + relatedObject.id }); })),
            description && React.createElement("div", { className: "cardListItem__description" },
                React.createElement(RichTextEditor, { value: description, setValue: function () { return null; }, referenceCollection: chips, onChipClick: onChipClick, readOnly: true })),
            tags && tags.length > 0 && React.createElement("div", { className: "cardListItem__chips" }, tags.map(function (tag) { return React.createElement(Chip, { label: tag.name, onClick: function (e) { return handleTagClick(e, tag); }, key: "tag-" + tag.id }); })))));
};
export default CardListItem;
//# sourceMappingURL=CardListItem.js.map